import React, { useRef, useState } from "react";
import { api } from "@/lib/api";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export function ImageUpload({ value, onChange, testid }) {
  const ref = useRef();
  const [busy, setBusy] = useState(false);

  const onFile = async (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", f);
      const { data } = await api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onChange(`${BACKEND_URL}${data.url}`);
    } catch (err) {
      alert(err.response?.data?.detail || "Upload failed");
    } finally {
      setBusy(false);
      e.target.value = "";
    }
  };

  return (
    <div className="flex items-center gap-3">
      {value ? (
        <img src={value} alt="preview" className="w-16 h-16 rounded-lg object-cover border border-[var(--line)]" />
      ) : (
        <div className="w-16 h-16 rounded-lg bg-[var(--cream-2)] border border-[var(--line)]" />
      )}
      <input ref={ref} type="file" accept="image/*" hidden onChange={onFile} data-testid={testid} />
      <button type="button" onClick={() => ref.current?.click()} disabled={busy}
        className="btn-outline-gold rounded-md px-4 py-2 text-xs">
        {busy ? "Uploading…" : "Change Photo"}
      </button>
    </div>
  );
}
